import * as StringUtil from "./stringHelpers";

const sharedTravellerRequiredFields = [
  "firstName",
  "lastName",
  "dateOfBirth",
  "emailAddress",
  "passportNumber",
  "passportExpiryDate",
  "passportIssuingCountry",
];

const leadTravellerRequiredFields = [
  "address",
  "homePhone",
  "travelPhone",
  "countryOfResidence",
  "outboundFlight",
  "returnFlight",
  "emergencyContactName",
  "emergencyContactNumber",
  ...sharedTravellerRequiredFields];

function getRequiredFieldNames(traveller: ILeadTravelerDetails | ITravelerDetails) {
  const isLeadTraveler = traveller.travelerNumber <= 1;
  const requiredFields = isLeadTraveler ? leadTravellerRequiredFields : sharedTravellerRequiredFields;

  const undefinedFields = requiredFields.filter(field => {
    return traveller[field] == null;
  });

  return undefinedFields;
}

export function getTravellersWithMissingDetails(enquiry: IEnquiryOutput): {name: string, fields: string[]}[] {
  if (!enquiry) {
    return [];
  }
  else if (!enquiry.leadTravelerDetails) {
    return [{ name: "Lead traveller", fields: leadTravellerRequiredFields.map(field => StringUtil.camelCaseToLowerCase(field)) }];
  }

  const otherTravellers = enquiry.travelerDetails ? enquiry.travelerDetails.map(t => t as ILeadTravelerDetails) : [];

  const travelersWithReminders = [enquiry.leadTravelerDetails, ...otherTravellers]
    .map((travelerDetails) => {
        const undefinedFields = getRequiredFieldNames(travelerDetails)
          .map(field => StringUtil.camelCaseToLowerCase(field));

        return {
          name: `${travelerDetails.firstName} ${travelerDetails.lastName}`,
          fields: undefinedFields,
        };
    })
    .filter(t => t.fields.length > 0);

  return travelersWithReminders;
}

export function isEnquiryCancellable(enquiry: IEnquiryOutput) {
  const cancellableStatuses = [EnquiryStatus.Booked, EnquiryStatus.FullyPaid, EnquiryStatus.InProgress, EnquiryStatus.Complete];
  return cancellableStatuses.indexOf(enquiry.enquiryStatus) !== -1; // Can't use Array.includes because IE11
}
